import { cn } from '@/lib/utils';
import { MaterialSymbol } from '@/components/ui/material-symbol';

interface SdkComingSoonBannerProps {
  className?: string;
  /** Tighter layout for sidebars / stacked rails */
  compact?: boolean;
}

/**
 * Platform-wide notice: Arcadia Game SDK is not finalized yet; MD docs may remain as previews.
 */
export function SdkComingSoonBanner({ className, compact }: SdkComingSoonBannerProps) {
  if (compact) {
    return (
      <div
        role="status"
        className={cn(
          'flex gap-2 rounded-xl border border-amber-500/35 bg-amber-500/10 px-3 py-2 text-[11px] leading-snug text-amber-100',
          className,
        )}
      >
        <MaterialSymbol name="schedule" className="mt-0.5 shrink-0 text-sm text-amber-300" aria-hidden />
        <span>
          <span className="font-display font-semibold text-amber-50">SDK coming soon.</span>{' '}
          Documentation below is a preview while we finish review.
        </span>
      </div>
    );
  }

  return (
    <div
      role="status"
      className={cn(
        'flex items-start gap-3 rounded-2xl border border-[var(--arc-cyan-primary)]/30 bg-[var(--arc-cyan-primary)]/10 px-4 py-3 text-sm text-arc-text-main',
        className,
      )}
    >
      <MaterialSymbol name="construction" className="mt-0.5 shrink-0 text-xl text-[var(--arc-cyan-primary)]" />
      <div>
        <p className="font-display font-semibold text-[var(--arc-cyan-primary)]">Arcadia Game SDK · coming soon</p>
        <p className="mt-1 text-arc-text-muted">
          Integration guides and references here are preview-only until we publish the reviewed SDK release.
        </p>
      </div>
    </div>
  );
}

export function SdkComingSoonBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border border-amber-500/35 bg-amber-500/10 px-1.5 py-px font-display text-[10px] font-bold uppercase tracking-wide text-amber-100',
        className,
      )}
    >
      SDK soon
    </span>
  );
}
